import { useScope } from "@state/scopeContext.lib";
import { WORKSPACE_USER_CACHE_KEYS } from "./useWorkspaceUserCache";
import { useClearUserCache } from "./useClearUserCache";

/**
 * This call clears all cache that is workspace scoped.
 */
export function useClearWorkspaceUserCache(): () => void {
    const { activeWorkspaceKey } = useScope();

    return useClearUserCache(activeWorkspaceKey, WORKSPACE_USER_CACHE_KEYS);
}
